import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
import { isNullOrUndefined } from 'util';

@Injectable()
export class UrlHelperService {
    constructor(
        private http: HttpClient, /* Your favorite Http requester */
    ) {
    }

    get(url: string): Observable<any> {
        return new Observable((observer: Subscriber<any>) => {
            let objectUrl: string = null;

            this.http
                .get(url, {
                    responseType: 'blob'
                })
                .subscribe(m => {
                	if(!isNullOrUndefined(m)) {
                    	objectUrl = URL.createObjectURL(m);
                    }
                    observer.next(objectUrl);
                });

            return () => {
                if (objectUrl) {
                    URL.revokeObjectURL(objectUrl);
                    objectUrl = null;
                }
            };
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/base/util/url-helper.service.ts